// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { ActivityDto } from './ActivityDto';
import { QbContactBaseDto } from './QbContactBaseDto';
import { UserDto } from './UserDto';
import { ActivityTypeDto } from './ActivityTypeDto';

// AbilityIntranet.Data.Intranet.ActivityFollowupDto
export class ActivityFollowupDto {
    public previousActivity: ActivityDto = null;
    public contact: QbContactBaseDto = null;
    public assignedTo: UserDto = null;
    public timeScheduled: Date = null;
    public activityType: ActivityTypeDto = null;
}


    



